<script>
    import * as ze from "@axel669/zephyr"

    import { numericInput } from "./numeric.js"

    import BagInfo from "./bag-info.svelte"

    let {
        nextBag = $bindable()
    } = $props()

    const { close } = ze.modalContext()
</script>

<ze.Dialog w="min(70vw, 320px)" card>
    {#snippet header()}
        <ze.Titlebar>
            {#snippet title()}
                <ze.Text title>Add Bag</ze.Text>
            {/snippet}
        </ze.Titlebar>
    {/snippet}

    <BagInfo bind:bag={nextBag} />

    {#snippet footer()}
        <ze.Grid cols="1fr 1fr">
            <ze.Button flat color="@danger" onclick={() => close(false)}>
                Cancel
            </ze.Button>
            <ze.Button flat color="@secondary" onclick={() => close(true)}>
                Add Bag
            </ze.Button>
        </ze.Grid>
    {/snippet}
</ze.Dialog>
